import * as apiServices from "../services/apiServices";
import request from "../services/requestService";

export const getUserProfileInfoAction = (requestMethod = request, id) => {
  return requestMethod(apiServices.getUsersInfo(id))
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
};
